import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';

import { getCurrentUser } from '../../../store/selectors';
import { api } from '../../../models/api-url.model';
import { Node } from '../../../models/node.model';
import { State } from '../../../store/reducers';
import { ApiService } from '../api';

@Injectable({
  providedIn: 'root',
})
export class NodeService {
  private readonly store = inject<Store<State>>(Store);

  private readonly apiService = inject(ApiService);

  getDownNodes(): Observable<Node[]> {
    let params: Record<string, string> = {};
    this.store
      .select(getCurrentUser)
      .pipe(take(1))
      .subscribe((currentUser) => {
        if (currentUser !== null && currentUser !== undefined) {
          params = {
            Orion_UserID__c: currentUser?.Orion_UserID__c || '',
            Orion_Password__c: currentUser?.Orion_Password__c || '',
          };
        }
      });

    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      httpParams = httpParams.set(key, params[key]);
    });
    return this.apiService.get(api.nodesDownURL, { params: httpParams });
  }
}
